"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var react_2 = require("react");
var useDirty = function (chance) {
    if (chance === void 0) { chance = 0; }
    var _a = __read((0, react_2.useState)(0), 2), count = _a[0], setCount = _a[1];
    var makeDirty = function () { return setCount(function (prev) { return prev + 1; }); };
    var isDirty = count > chance;
    return {
        makeDirty: makeDirty,
        isDirty: isDirty,
    };
};
exports.default = useDirty;
